import { BillGateway } from '../domain/bill.gateway';

export class DeleteUseCase {
    constructor(private gate: BillGateway) {}

    async execute(id: string): Promise<Boolean> {
        return this.gate.delete(id);
    }
}
